import { Getter } from "vuex";
import { IState, ISelectedFilter } from './state';

const total: Getter<IState, IState> = (state) => state.total;
const hits: Getter<IState, IState> = (state) => state.hits;
const query: Getter<IState, IState> = (state) => state.query;
const suggestion: Getter<IState, IState> = (state) => state.suggestion;
const numberToShow: Getter<IState, IState> = (state) => state.numberToShow;
const tags: Getter<IState, IState> = (state) => state.tags;
const selectedFilters: Getter<IState, IState> = (state) => state.selectedFilters;
const typeFilters: Getter<IState, IState> = (state) => state.typeFilters;

export default {
  total, hits, query, numberToShow, suggestion, tags, selectedFilters, typeFilters
}
